import { Eye, X } from 'lucide-react'
import { DocumentFileName } from './DocumentFileName'

interface PendingProfileDocumentProps {
    file: File
    onPreview: () => void
    onRemove: () => void
}

/** A file chosen on a form that has not been saved yet: it uploads with the save. */
export const PendingProfileDocument = ({ file, onPreview, onRemove }: PendingProfileDocumentProps) => (
    <span className="flex min-w-0 items-center rounded-lg bg-default px-2 py-1 text-xs">
        <button
            type="button"
            className="flex min-w-0 items-center gap-1 hover:text-accent"
            aria-label={`Preview ${file.name}`}
            onClick={(event) => {
                event.stopPropagation()
                onPreview()
            }}
        >
            <Eye className="h-3 w-3" />
            <DocumentFileName fileName={file.name} />
        </button>
        <button
            type="button"
            className="ml-1 text-foreground-muted hover:text-danger"
            aria-label={`Remove ${file.name}`}
            onClick={(event) => {
                event.stopPropagation()
                onRemove()
            }}
        >
            <X className="h-3 w-3" />
        </button>
    </span>
)
